import { put } from "redux-saga/effects";

import { UpdateUserMetadataResponse } from "redmond";
import { actions } from "../actions";
import { updateUserMetadata } from "../../../api/v0/user/updateUserMetadata";
import { wishlistFtuxLocalStorageKey } from "./fetchHasSeenWishlistFtuxSaga";

export function* updateHasSeenWishlistFtuxSaga(
  action: actions.IUpdateHasSeenWishlistFtux
) {
  try {
    const res: UpdateUserMetadataResponse = yield updateUserMetadata({
      userMetadata: {
        hasSeenWishlistsFtux: action.hasSeenWishlistFtux,
      },
    });

    if (res.Response !== "Success") {
      throw new Error("Failed to update metadata");
    }

    if (action.hasSeenWishlistFtux) {
      localStorage.setItem(wishlistFtuxLocalStorageKey, "true");
    }
    yield put(actions.setHasSeenWishlistFtux(action.hasSeenWishlistFtux));
  } catch (e) {
    console.error(e);
    // Allow the ftux popup to close if there was an error updating the metadata
    localStorage.setItem(wishlistFtuxLocalStorageKey, "true");
    yield put(actions.setHasSeenWishlistFtux(true));
  }
}
